import React from "react";
import Modal from "../Modal";
import { LuInfo } from "react-icons/lu";
import Tooltip from "../Tooltip/Tooltip";
import moment from "moment";

const EmailDetailsModal = ({ open, setOpen, data = {} }) => {
  if (!open) return null;
  return (
    <Modal
      title="View Email"
      open={open}
      setOpen={setOpen}
      okText=""
      canelText=""
      type="email-activity"
      noActions={true}
    >
      <div className="template-details-outer" style={{ width: "85%" }}>
        <div className="template-details pt-2">
          <div className="template-name">
            <h6>Template</h6>
            <p className="email-template-name ">
              {data.template
                .substring(data.template.lastIndexOf("/") + 1)
                .split("_")
                .join(" ")}
            </p>
          </div>
          <div className="email-send-date">
            <Tooltip position="right" text={"Date format: DD.MM.YYYY"}>
              <h6>Send Date</h6>
            </Tooltip>
            <div className="d-flex align-items-center gap-2">
              <span>
                {moment
                  .utc(data.sent_datetime)
                  .local()
                  .format("DD.MM.YYYY HH:mm")}
              </span>
              <Tooltip
                position="right"
                text={`${moment
                  .utc(data.sent_datetime)
                  .format("DD.MM.YYYY HH:mm")} UTC`}
              >
                <LuInfo className="table__date__icon" size={19}/>
              </Tooltip>
            </div>
          </div>
        </div>
        <div className="contact-email">
          <h6>Receiver Email</h6>
          <p>{data.contact_email}</p>
        </div>
      </div>
      <p
        className="email-template"
        style={{ pointerEvents: "none" }}
        dangerouslySetInnerHTML={{ __html: data?.content }}
      ></p>
    </Modal>
  );
};

export default EmailDetailsModal;
